module.exports = __webpack_public_path__ + "img/YF-XM.b25700bc.png";